import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';    // 默认主题
// import $ from 'jquery';
import '../static/css/icon.css';
import "babel-polyfill";
import store from './store';
import './icons' // icon
import {post_,post2} from './components/js/request.js';
import * as cusFilter from './components/js/filters.js';
import {download} from '@/components/js/request'
import i18n from './lang' // internationalization


Vue.use(ElementUI, {
  size: 'small', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.prototype.$post_ = post_;
Vue.prototype.$post2 = post2;

Vue.prototype.$axios = axios;
Vue.prototype.$download = download;

// 导出的是对象，可以直接通过key和value来获得过滤器的名和过滤器的方法
Object.keys(cusFilter).forEach(key => {
    Vue.filter(key, cusFilter[key])
})


//刷新的时候重新加载路由
let localRules = window.localStorage.getItem('rules');
if(localRules){
    localRules = JSON.parse(localRules);
    store.dispatch('GenerateRoutes',localRules).then(() => {
       router.addRoutes(store.getters.addRouters)
    })
}
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
	
    next();
})

new Vue({
   router,
   store,
   i18n,
    render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js